module.exports = __webpack_public_path__ + "img/total-return-blue.b3e6763b.png";